import React from 'react';

import useBuilderConstructorGridInputs from '../hooks/useBuilderConstructorGridInputs';

import DesktopGridSortDropdown from './DesktopGridSortDropdown';

const DesktopGridHeader = () => {
  const { gridHeader } = useBuilderConstructorGridInputs();

  return (
    <div className="flex mt-[32px] mb-[24px] px-[32px] pt-[20px]">
      <div className="mr-[32px] w-[268px] grow-0 shrink-0" />
      <div className="flex justify-between items-center w-full">
        <h1 className="font-bold text-[24px]">{gridHeader}</h1>
        <DesktopGridSortDropdown />
      </div>
    </div>
  );
};

export default DesktopGridHeader;
